import { render, staticRenderFns } from "./TicketsSupervisor.vue?vue&type=template&id=6c721614&"
import script from "./TicketsSupervisor.vue?vue&type=script&lang=js&"
export * from "./TicketsSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports